import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { React } from 'react';

export default function TableIconAction({icon, props, onClick}) {

    
    const tooltip = props.tooltip

    const handleClick = (e) =>{
        // Se o ícone já tem onClick próprio (como o PaymentButton), não chama o onClick da tabela
        if (icon && icon.props && icon.props.onClick) {
            return;
        }
        onClick(e)
    } 
    
    
    return (
        <>
            <Tooltip title={tooltip} arrow>
            <IconButton onClick={handleClick}>
                {icon}
            </IconButton>
                
            </Tooltip>
            
        </>
    )
   
};

